module.exports = __webpack_public_path__ + "img/02-Eisai-logo1.532a2b0c.png";